import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { INVESTMENT_TYPES } from './investmentConstants';
import FieldError from '../ui/FieldError';
import FieldTip from '../ui/FieldTip';

const InvestmentBasicFields = ({ formData, onFieldChange, config, errors = {}, onBlur, hideType = false }) => (
  <div className={hideType ? "" : "grid grid-cols-1 md:grid-cols-2 gap-4"}>
    <div className="space-y-2">
      <Label htmlFor="name" className="portfolio-input-label">Investment Name <span className="text-red-500">*</span><FieldTip field="investment_name" /></Label>
      <Input id="name"
        data-testid="investment-name-input"
        placeholder="e.g. Apple Inc, Treasury Bond, etc."
        value={formData.name}
        onChange={(e) => onFieldChange('name', e.target.value)}
        onBlur={() => onBlur?.('name')}
        className={`portfolio-input ${errors.name ? 'border-red-400' : ''}`} />
      <FieldError error={errors.name} />
    </div>
    {!hideType && (
      <div className="space-y-2">
        <Label htmlFor="type" className="portfolio-input-label">Investment Type <span className="text-red-500">*</span><FieldTip field="investment_type" /></Label>
        <Select value={formData.type} onValueChange={(value) => onFieldChange('type', value)}>
          <SelectTrigger data-testid="investment-type-select" className={`portfolio-input ${errors.type ? 'border-red-400' : ''}`}>
            <SelectValue placeholder="Select investment type" />
          </SelectTrigger>
          <SelectContent>
            {config?.investment_types ?
              config.investment_types.map(type => (
                <SelectItem key={type.value} value={type.value}>{type.label}</SelectItem>
              )) :
              Object.entries(INVESTMENT_TYPES).map(([key, label]) => (
                <SelectItem key={key} value={key}>{label}</SelectItem>
              ))
            }
          </SelectContent>
        </Select>
        <FieldError error={errors.type} />
      </div>
    )}
  </div>
);

export default InvestmentBasicFields;
